module.exports = __webpack_public_path__ + "img/pay.0af8340e.png";